import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_PRODUCT,
    GET_UPI_PRODUCT,
    GET_CATALOG_PRODUCT,
    GET_AI_PRODUCT,
    GET_VIN_PRODUCT,
    GET_IMAGE_PRODUCT,
} from './asinTypes'

export default (state, action) => {
    switch (action.type) {
        case GET_PRODUCT:
            return {
                ...state,
                all_products: action.payload,
            }
        case GET_UPI_PRODUCT:
            return {
                ...state,
                upc_products: action.payload,
            }
        case GET_CATALOG_PRODUCT:
            return {
                ...state,
                catalog_products: action.payload,
            }
        case GET_AI_PRODUCT:
            return {
                ...state,
                ai_products: action.payload,
            }
        case GET_VIN_PRODUCT:
            return {
                ...state,
                vin_products: action.payload,
            }
        case GET_IMAGE_PRODUCT:
            return {
                ...state,
                image_products: action.payload,
            }

        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
